<app-order-price-list-custom-item-modal></app-order-price-list-custom-item-modal>
<app-order-add-grade></app-order-add-grade>
<app-order-material-uplift></app-order-material-uplift>
<app-order-add-account></app-order-add-account>

<app-tabs>

  <app-tab title='Main Details' [invalid]="!this.isTabComplete('main')">
    <div class="form-row">
      <div class="form-group col-md-4">

        <label><strong>Customer:  </strong></label>
        <ng-select [(ngModel)]="this.order.accountId" class='form-control' [class.is-invalid]='this.order.accountId === -1' (change)='this.order.accountId = +$event; this.updateSiteList(this.order.accountId); changeAccount(this.order.accountId) ; this.order.siteId = -1; this.order.account.id = this.order.accountId'>
          <ng-option  [value]='-1'>
            Select a customer or add a new one
          </ng-option>
          @for (item of this.accountList; track item) {
            <ng-option [value]='item.id' [selected]='this.order.accountId === item.id'>
              {{ item.name }}
            </ng-option>
          }
        </ng-select>

        <button class='btn btn-primary' type='button' (click)='this.openModal("addCustomerAccountOrderModal");'><i class="fa fa-plus"></i> Add Company</button>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-4">

        <label><strong>Site: {{this.sitesList.length}}</strong></label>
        @if (this.order.accountId !== -1 && this.sitesList.length !== 0) {
          <span>
            <ng-select [(ngModel)]="this.order.siteId" class='form-control' [class.is-invalid]='this.order.siteId === -1' (change)='this.order.siteId = +$event;this.order.site.id = this.order.siteId;' >
              <ng-option  [value]='-1' [selected]='this.order.siteId === -1'>
                Select a Site or add a new one
              </ng-option>
              @for (item of this.sitesList; track item) {
                <ng-option [value]='item.id' [selected]='this.order.siteId === item.id'>
                  {{ item.name }}
                </ng-option>
              }
            </ng-select>
          </span>
          }<br/>
          @if (this.account.id !== -1) {
            <span>
              <button class='btn btn-primary' type='button' (click)='this.openModal("addSimpleNewSiteOrderModal");'><i class="fa fa-plus"></i> Add Site</button>
            </span>
          }
          @if (this.account.id === -1) {
            <span>
              <label><strong>Please select or add Company to see available Sites</strong></label>
            </span>
          }
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-4">
          <p>@if (this.order.id !== -1) {
            <button class='btn btn-primary' type='button' [routerLink]='"/orders/change/"+ this.order.id +"/accounts/"'>Edit Customer & Site</button>
          }</p>
        </div>
      </div>
      <div class='form-row'>
        <div class="form-group col-md-4">
          <label>From Time</label>
          <input (keyup)='setTimeBasedOnRange()' [(ngModel)]='this.fromTime' type="time" name='name' class="form-control" [disabled]="['AM', 'PM', this.getAnyTimeOption()].indexOf(this.order.time) !== -1">
        </div>

        <div class="form-group col-md-4">
          <label>To Time</label>
          <input (keyup)='setTimeBasedOnRange()' [(ngModel)]='this.toTime' type="time" name='name' class="form-control" [disabled]="['AM', 'PM', this.getAnyTimeOption()].indexOf(this.order.time) !== -1">
        </div>

        <div class="form-group col-md-4">

          <input type='radio' name='group[]' value='1' [checked]="['AM', 'PM', getAnyTimeOption()].indexOf(this.order.time) === -1" (change)='onTimeOptionClicked($event)'/><label>Time Window</label>
          <input type='radio' name='group[]' value='AM' [checked]='this.order.time === "AM"' (change)='onTimeOptionClicked($event)'/><label>AM</label>
          <input type='radio' name='group[]' value='PM' [checked]='this.order.time === "PM"' (change)='onTimeOptionClicked($event)'/><label>PM</label>
          <input type='radio' name='group[]' [value]='getAnyTimeOption()' [checked]='this.order.time === getAnyTimeOption()' (change)='onTimeOptionClicked($event)' /><label>{{ this.getAnyTimeOption() }}</label>
        </div>
      </div>


      <div class="form-row">
        <div class="form-group col-md-4">
          <label>Date</label>
          <input type="date" name='name' [(ngModel)]='this.order.date' [class.is-invalid]='!this.order.date' class="form-control">
        </div>

        <div class="form-group col-md-4">
          <label>PO Number <button class='btn btn-primary' type='button' (click)='this.copyPOToSite()'>Copy to Site</button></label>
          <input type="text" name='name' [(ngModel)]='this.order.poNumber' class="form-control">
        </div>
        <div class="form-group col-md-4">
          <label>Order Number</label>
          <input type="text" name='name' [(ngModel)]='this.order.orderNumber' class="form-control">
        </div>
        <div class="form-group col-md-4">
          <label>Collection Number</label>
          <input type="text" name='name' [(ngModel)]='this.order.collectionNumber' class="form-control">
        </div>
        <div class="form-group col-md-4">
          <label>Unique Reference Number</label>
          <input type="text" name='name' [(ngModel)]='this.order.uniqueReference' class="form-control">
        </div>

        <div class="form-group col-md-4">
          <label>Order Type</label>
          <select class='form-control' [class.is-invalid]='this.order.orderTypeId === -1' (change)='this.updateOrderDetails($event)'>
            <option value='-1'>Select a order type</option>
            @for (item of this.types; track item) {
              <option [value]='item.id' [selected]='this.order.orderTypeId === item.id'>{{ item.name }}</option>
            }
          </select>
        </div>
        <div class="form-group col-md-4" [hidden]='this.order.orderTypeId !== 8'>
          <label>Contract</label>
          <select class='form-control' (change)='this.order.contractId = +$event.target.value;'>
            <option value='-1'>Select a contract</option>
            @for (item of this.contracts; track item) {
              <option [value]='item.id' [selected]='item.id === this.order.contractId'>{{ item.name }}</option>
            }
          </select>
        </div>
        <!-- if skip order then select skip order type -->
        @if (this.order.orderTypeId === 1) {
          <div class="form-group col-md-4">
            <label>Skip Order Type</label>
            <select class='form-control' [class.is-invalid]='this.order.skipOrderTypeId === -1' (change)='this.order.skipOrderTypeId = +$event.target.value; this.order.skipOrderType.id = this.order.skipOrderTypeId'>
              <option value='-1'>Select a skip order type</option>
              @for (item of this.skipOrderTypes; track item) {
                <option [value]='item.id' [selected]='this.order.skipOrderTypeId === item.id'>{{ item.name }}</option>
              }
            </select>
          </div>
        }
        <!-- if skip order then select skip order type -->
        @if (this.order.orderTypeId === 8) {
          <div class="form-group col-md-4">
            <label>Shredder Order Type</label>
            <select class='form-control' [class.is-invalid]='this.order.shredderOrderTypeId === -1' (change)='this.order.shredderOrderTypeId = +$event.target.value; this.order.shredderOrderType.id = this.order.shredderOrderTypeId'>
              <option value='-1'>Select a shredder order type</option>
              @for (item of this.shredderTypes; track item) {
                <option [value]='item.id' [selected]='this.order.shredderOrderTypeId === item.id'>{{ item.name }}</option>
              }
            </select>
          </div>
        }

        @if (this.order.orderTypeId === 1) {
          <div class="form-group col-md-4">
            <label>Container Size</label>
            <select class='form-control' [class.is-invalid]='this.order.containerSizeTypeId === -1' (change)='this.order.containerSizeTypeId = +$event.target.value; this.order.containerSizeType.id = this.order.containerSizeTypeId;'>
              <option value='-1'>Select a container size</option>
              @for (item of this.containerSizes; track item) {
                @if (item.vehicleTypeId === 1 || item.vehicleTypeId === 2) {
                  <option [value]='item.id' [selected]='this.order.containerSizeTypeId === item.id'>{{ item.size + ' ' + item.unit.name }}</option>
                }
              }
            </select>
          </div>
        }
        @if (this.order.orderTypeId === 1 || this.order.orderTypeId === 8) {
          <div class="form-group col-md-4">
            <label>Container type</label>
            <select class='form-control' [class.is-invalid]='this.order.containerTypeId === -1' (change)='this.order.containerTypeId = +$event.target.value; this.order.containerType.id = this.order.containerTypeId;'>
              <option value='-1'>Select a container type</option>
              @for (item of this.containerTypes; track item) {
                <option [hidden]='((item.name.toLowerCase() === "bag" || item.name.toLowerCase() === "cabinet") && this.order.orderTypeId !== 8) || ((item.name.toLowerCase() !== "bag" && item.name.toLowerCase() !== "cabinet") && this.order.orderTypeId === 8)' [value]='item.id' [selected]='this.order.containerTypeId === item.id'>{{ item.name }}</option>
              }
            </select>
          </div>
        }
        <div class="form-group col-md-4">
          <label>Grade</label>
          <ng-select [(ngModel)]="this.order.gradeId" class='form-control' [class.is-invalid]='this.order.gradeId === -1' (change)='this.order.gradeId = +$event; this.order.grade = {}; this.order.grade.id = this.order.gradeId;'>
            @for (item of this.grades; track item) {
              <ng-option [value]='item.id' [selected]='this.order.gradeId === item.id'>{{ item.name }}@if (item.ewcCodes && item.ewcCodes !== "") {
                ({{ item.ewcCodes }})
              }</ng-option>
            }
          </ng-select>
          <button class='btn btn-primary' type='button' (click)='this.openModal("orderAddGradeModal");'>+ Add grade</button>
        </div>
        <div class="form-group col-md-4">
          <label>{{ getTipName() }}</label>
          <ng-container>
            <ng-select [(ngModel)]="this.order.tipSiteId" class='form-control' [class.is-invalid]='this.order.tipSiteId === -1' (change)='this.order.tipSiteId = +$event; this.order.tipSite = {}; this.order.tipSite.id = this.order.tipSiteId;'>
              @for (item of this.tips; track item) {
                <ng-option [value]='item.id'>{{ item.name }}</ng-option>
              }
            </ng-select>
          </ng-container>
        </div>
        @if (this.order.orderTypeId === 3) {
          <div class="form-group col-md-4">
            <label>Tip fee (if zero fee is not required)</label>
            <input type="number" name='name' [(ngModel)]='this.order.tipFee' class="form-control">
          </div>
        }
        @if (this.order.orderTypeId === 3 && this.order.tipFee > 0) {
          <div class="form-group col-md-4">
            <label>Tip unit</label>
            <select class='form-control' (change)='this.order.tipUnitId = +$event.target.value'>
              @for (item of this.units; track item) {
                <option [selected]='item.id === this.order.tipUnitId' [value]='item.id'>{{ item.name }}</option>
              }
            </select>
          </div>
        }
        <div class="form-group col-md-12">
          <label for="inputPassword4">Description </label>
          <textarea name='notes' [(ngModel)]='this.order.description' class="form-control"></textarea>
        </div>
        <div class="form-group col-md-12">
          <label for="inputPassword4">Driver Notes </label>
          <textarea name='notes' [(ngModel)]='this.order.driverNotes' class="form-control"></textarea>
        </div>
      </div>

      <br />
      <br />

      @if (this.order.id === -1) {
        @if (!this.isRepeat) {
          <button class='btn btn-primary' (click)='this.isRepeat = true'>Select additional dates</button>
        }
        @if (this.isRepeat) {
          <h2 class='header'>Select additional dates</h2>
        }
        @if (this.isRepeat) {
          <span>Click on the datepicker below to select additional dates, you may select between months.</span>
        }
        <div id="datepicker" data-language='en'  data-multiple-dates="true" [hidden]='!this.isRepeat'></div>
        <br />
        <br />
      }
    </app-tab>

    <app-tab title='Product Details' [invalid]="this.orderLines.orderLines.length === 0">
      <br />
      <br />

      @if (!isTipperEdit()) {
        <button class='btn btn-secondary' (click)='this.priceListType = "quote"; this.orderLines.orderLines = []' [class.btn-success]='this.priceListType === "quote"' type='button'>Quote</button>
        }&nbsp;&nbsp;
        @if (!isTipperEdit()) {
          <button class='btn btn-secondary' (click)='this.priceListType = "pricelist"; this.orderLines.orderLines = []' [class.btn-success]='this.priceListType === "pricelist"' type='button'>Price List</button>
        }

        <br />
        <br />

        @if (this.priceListType === "pricelist") {
          <h3>Price Lists</h3>
          <button class='btn btn-secondary' (click)='this.openModal("orderPriceListAddItemModal")'><i class="fas fa-plus"></i> Add From Price List</button>&nbsp;&nbsp;
          <button type='button' class='btn btn-secondary' (click)='this.openModal("orderCustomItemModal")'><i class="fas fa-plus"></i> Add Custom Item</button>
          <br />
          <br />
          <table class="table">
            <thead>
              <th>Name</th>
              <th>Qty</th>
              <th>Unit</th>
              <th>Base Price(&pound;)</th>
              <th>Total Price(&pound;)</th>
              <th></th>
            </thead>
            <tbody>
              @for (orderLine of this.orderLines.orderLines; track orderLine) {
                <tr>
                  <td><input class='form-control' type='text' [(ngModel)]="orderLine.name"></td>
                  <td><input class='form-control' type='number' [(ngModel)]='orderLine.qty' [readOnly]='isTipperEdit()'></td>
                  <td>
                    <select class='form-control' (change)='orderLine.unitId = +$event.target.value' [readOnly]='isTipperEdit()'>
                      @for (unit of this.units; track unit) {
                        <option [selected]='unit.id === orderLine.unitId' [value]='unit.id'>{{ unit.name }}</option>
                      }
                    </select>
                  </td>
                  <td><input class='form-control' type='number' [(ngModel)]="orderLine.price"></td>
                  <td>{{ orderLine.price * orderLine.qty }}</td>
                  <td>
                    <input type='checkbox'   [(ngModel)]="orderLine.isPrimaryCharge"
                      [ngModelOptions]="{standalone: true}" />&nbsp;
                      Is Primary Charge?
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          }

          @if (this.priceListType === "quote") {
            <h3>Quote Pricing</h3>
            @if (this.orderLines.orderLines.length === 0) {
              <div class='alert alert-danger'>
                Please select at least one product for this order
              </div>
            }
            <div class="form-row">
              <div class="form-group col-md-4">
                <label>Quote</label>
                <select class='form-control' (change)='this.onQuoteChanged($event)'>
                  <option value='-1'>Select a quote</option>
                  @for (item of this.quotes; track item) {
                    <option [selected]='this.quoteId === item.id' [value]='item.id'>{{ item.name }}({{ item.quoteNumber }}))</option>
                  }
                </select>
              </div>
            </div>
            @if (this.quoteLines.length > 0) {
              <table class="table">
                <thead>
                  <th>Name</th>
                  <th>Qty</th>
                  <th>Unit</th>
                  <th>Base Price(&pound;)</th>
                  <th>Total Price(&pound;)</th>
                  <th></th>
                </thead>
                <tbody>
                  @for (item of this.orderLines.orderLines; track item) {
                    <tr>
                      <td>{{ item.quoteLine.product.name }}</td>
                      <td>
                        <input type="number" min='0' name='name' class="form-control" [(ngModel)]='item.qty' [readOnly]='item.isPrimaryCharge'>
                      </td>
                      <td>
                        {{ item.quoteLine.product.unit.name }}(s)
                      </td>
                      <td>
                        {{ item.price }}
                      </td>
                      <td>
                        {{ getTotalPriceForOrderLine(item).toFixed(2) }}
                      </td>
                      <td>
                        <input type='checkbox'   [(ngModel)]="item.isPrimaryCharge"
                          [ngModelOptions]="{standalone: true}" />&nbsp;
                          Is Primary Charge?
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              }
            }


          </app-tab>

          <app-tab title='Other Charges'>

            <button class='btn btn-secondary' type='button' (click)='this.openModal("orderMaterialUpliftModal")'><i class="fas fa-plus"></i> Add Material Uplift charge</button>&nbsp;&nbsp;

            <br />
            <br />
            <div class='row'>
              <div class='col-md-4'>
                <label>Employee wage cost</label>
                <input type='number' class='form-control' [(ngModel)]="this.order.employeeWageCost" />
              </div>
            </div>
            <br />
            <br />

            <h3>Material Uplift Charges</h3>
            <table class='table'>
              <thead>
                <th>Account</th>
                <th>Name</th>
                <th>Unit</th>
                <th>Qty</th>
                <th>Price</th>
              </thead>
              <tbody>
                @for (uplift of this.materialUplifts.materialUplifts; track uplift) {
                  <tr>
                    <td><ng-select [(ngModel)]="uplift.accountId" (change)='uplift.accountId= +$event; setAccount();'>
                      @for (item of this.accounts; track item) {
                        <ng-option [value]='item.id'>{{ item.name }}</ng-option>
                      }
                    </ng-select></td>
                    <td><input class='form-control' type='text' [(ngModel)]="uplift.name" /></td>
                    <td><select class='form-control' (change)='uplift.unitId = +$event.target.value'>
                      @for (unit of this.units; track unit) {
                        <option [value]='unit.id' [selected]='unit.id === uplift.unitId'>{{ unit.name }}</option>
                      }
                    </select>
                    <td><input class='form-control' type='number' [(ngModel)]="uplift.qty" /></td>
                    <td><input class='form-control' type='number' [(ngModel)]="uplift.price" /></td>
                  </tr>
                }
              </tbody>
            </table>
          </app-tab>

          <app-tab title='Site Contact Details' [invalid]="!this.isTabComplete('contact')">
            <div class="form-row">
              <div class="form-group col-md-4">
                <label>Company Name</label>
                <input type="text" name='name' [(ngModel)]='this.order.companyName' class="form-control">
              </div>
              <div class="form-group col-md-4">
                <label>Contact Name</label>
                <input type="text" name='name' [(ngModel)]='this.order.contactName' class="form-control">
              </div>
              <div class="form-group col-md-4">
                <label>Contact Telephone</label>
                <input type="text" name='name' [(ngModel)]='this.order.contactTelephone' class="form-control">
              </div>
              <div class="form-group col-md-4">
                <label>Contact Email</label>
                <input type="email" name='name' [(ngModel)]='this.order.contactEmail' class="form-control">
              </div>
              <div class="form-group col-md-4">
                <label>Contact Address Line 1</label>
                <input type="text" name='name' [(ngModel)]='this.order.contactAddressLine1' class="form-control">
              </div>
              <div class="form-group col-md-4">
                <label>Contact Address Line 2</label>
                <input type="text" name='name' [(ngModel)]='this.order.contactAddressLine2' class="form-control">
              </div>
              <div class="form-group col-md-4">
                <label>Contact Address Line 3</label>
                <input type="text" name='name' [(ngModel)]='this.order.contactAddressLine3' class="form-control">
              </div>
              <div class="form-group col-md-4">
                <label>Contact City</label>
                <input type="text" name='name' [(ngModel)]='this.order.contactCity' class="form-control">
              </div>
              <div class="form-group col-md-4">
                <label>Contact Country</label>
                <input type="text" name='name' [(ngModel)]='this.order.contactCountry' class="form-control">
              </div>
              <div class="form-group col-md-4">
                <label>Site Contact Postcode</label>
                <input type="text" name='name' [(ngModel)]='this.order.contactPostCode' class="form-control">
                <app-address-picker [postcode]='this.order.contactPostCode' (onAddressFound)='this.foundContactAddress($event)'></app-address-picker>

              </div>
            </div>

            <!-- if skip and not saved allow sending of confirmation email -->
            @if (this.order.orderTypeId === 1 && this.order.id === -1) {
              <div class='form-row'>
                <div class='form-group'>
                  <label>Send confirmation email?</label>
                  <input type='checkbox'
                    [(ngModel)]="this.order.sendConfirmationEmail"
                    [ngModelOptions]="{standalone: true}"/>
                </div>
              </div>
            }

          </app-tab>



          @if (this.order.id > 0) {
            <app-tab title='History'>
              <table class="table">
                <thead>
                  <th>Person</th>
                  <th>Status</th>
                  <th>Message</th>
                  <th>When</th>
                </thead>
                <tbody>
                  @for (item of this.history; track item) {
                    <tr>
                      <td>{{ item.createdBy === -1 ? 'System' : item.user.firstName + ' ' + item.user.lastName }}</td>
                      <td>{{ item.orderStatus.name }}</td>
                      <td>{{ item.notes }}</td>
                      <td>{{ item.createdAt }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </app-tab>
          }
          @if (this.order.id !== -1) {
            <app-tab title='Discussion'>
              <app-discussion [data]='this.order' entity='order'></app-discussion>
            </app-tab>
          }
        </app-tabs>
        <app-order-add-site [account]='this.account'></app-order-add-site>
        <app-order-price-list-add-item [account]='this.account' [site]='this.site'></app-order-price-list-add-item>
